<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { onMounted, ref } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import { mdiPencil, mdiPlusCircle, mdiMagnify, mdiCircleMedium, mdiCircle, mdiCloudUploadOutline, mdiCloseCircle, mdiTrashCan, mdiStarOutline, mdiEye, mdiDownload } from "@mdi/js";
import VueSelect from "vue3-select-component";
import NotificationAlert from "@/Components/NotificationAlert.vue";
//import WebViewer from "@/Components/WebViewer.vue";

const props = defineProps({
    course: Object,
    classroom: Object,
    origin_type: String,
    id_user: Number,
    canRead: Boolean,
    canWrite: Boolean,
    canUpdate: Boolean,
    canDownload: Boolean,
    canDelete: Boolean,
    canReadSedes: Boolean,
    canWriteSedes: Boolean,
    apiSedes: Array,
    anioEscolar: String,
    back_link: String,
    factorDiferenciaSemanas: Number,
    semanasPrimerBimestre: Array,
    semanasSegundoBimestre: Array,
    semanasTercerBimestre: Array,
    semanasCuartoBimestre: Array,
    totalSemanas: Number,
    temas: Array,
    competencias: Array
});

const msg1 = ref('')
onMounted(() => {
    //console.log(msg)
    // msg1.value = msg
});

const backLink = ref(props.back_link ? '/#' + props.back_link : '')
const isModalActive = ref(false)
const selectedEvent = ref({})
const showDialog = ref(false)
const isModalDangerActive = ref(false);
const titleModal = ref('')
const isModalFullActive = ref(false);
const modalFullSrc = ref('');

const onEventClick = (event, e) => {
    selectedEvent.value = event
    showDialog.value = true
    // Prevent navigating to narrower view (default vue-cal behavior).
    e.stopPropagation()
}

const rowID = ref(0);
const rowAction = ref('');
const initModal = (id = 0, action = 'create', data = []) => {
    rowAction.value = action
    rowID.value = id;
    if (action == 'update') {
        showDialog.value = false

        formEvent.id = data['id']
        formEvent.start = data['start_datetime']
        formEvent.end = data['end_datetime']
        formEvent.title = data['title']
        formEvent.contentFull = data['contentFull']
        formEvent.type_source = data['class']
        formEvent.id_source = data['id_source']

        console.log(data['start'] + ' - ' + data['end'])
    }
    if (action == 'delete' || action == 'eliminar') {
        titleModal.value = 'eliminar'
        showDialog.value = false
        isModalDangerActive.value = true
        formEvent.id = rowID.value
    } else {
        // create
        isModalActive.value = true
    }

}

const isConfirm = () => {

    eventUpdateOrCreate(rowID.value, rowAction.value)
    isModalActive.value = false
    cleanVal()
}

const isCancel = () => {
    isModalActive.value = false
    cleanVal()
}

const cleanVal = (cleanEditor = 1) => {

    rowID.value = 0;
    rowAction.value = ''

    formEvent.id = 0
    formEvent.start = ''
    formEvent.end = ''
    formEvent.title = ''
    formEvent.contentFull = ''
    formEvent.type_source = 'user_private'
    formEvent.id_source = 0

    // Tarea
    /*
    if (cleanEditor) {// <-- No borrar si cierro el editor en nueva edición
        formTarea.label = ''
        formTarea.description = ''
        formTarea.end_date = null
        formTarea.status = 0
        tareaEditor.value.setContents('')// <-- Limpiar contenido de texto enriquecido
    } */
}

/**
 * Crear eventos
 */
const formEvent = useForm({
    id: 0,
    start: '',
    end: '',
    title: '',
    contentFull: '',
    type_source: 'user_private',
    id_source: 0,

    module_origin: 'documents'
})
const arrayEvent = ref([])
const errorEvent = ref('')
const prefijoRuta = 'file'
const eventUpdateOrCreate = (id = 0, action = '') => {
    let prefijo = prefijoRuta
    let ruta = prefijo + '-registrar';
    if (id > 0) {
        ruta = prefijo + '-actualizar';

        if (action == 'eliminar') {
            ruta = prefijo + '-eliminar';

            axios.post(route(ruta), formEvent).then((response) => {
                if (response.data.error) {
                    //showAlert(response.data.message, 'danger', 5)
                    //errorMessage.value = response.data.message
                    errorEvent.value = response.data.error;
                } else if (response.data.success) {
                    //showAlert(response.data.message, 'success', 2)
                    //successMessage.value == response.data.message

                    //Inertia.reload({ only: ['events', 'eventsnow'] })
                    //onToggle()
                    listarDocuments()
                    console.log('Evento eliminado')
                }

            }).catch((error) => {
                console.log(error);
            });

            return;
        }
    }

    // Registrar o actualizar
    if (formEvent.type_source == 'temario') {
        if (!formEvent.title || !formEvent.start || !formEvent.end || !formEvent.id_source) {
            errorEvent.value = 'Debe ingresar un tema, rango de fechas y un curso'
        } else {
            errorEvent.value = ''
        }
    } else {
        if (!formEvent.title || !formEvent.start || !formEvent.end) {
            errorEvent.value = 'Debe ingresar un título y rango de fechas'
        } else {
            errorEvent.value = ''
        }
    }

    if (!errorEvent.value) {
        axios.post(route(ruta), formEvent).then((response) => {
            if (response.data.error) {
                //showAlert(response.data.message, 'danger', 5)
                //errorMessage.value = response.data.message
                errorEvent.value = response.data.error;
            } else if (response.data.success) {
                //showAlert(response.data.message, 'success', 2)
                //successMessage.value == response.data.message

                //Inertia.reload({ only: ['events', 'eventsnow'] })
                //onToggle()
                console.log((id > 0 ? 'Evento actualizado' : 'Evento creado'))
            }

        }).catch((error) => {
            console.log(error);
        });
    }

}

const id_source = ref(0)
const type_source = ref('')


/**
 * Listar documents
 */
const anioSearch = ref(props.anioEscolar)
const type = ref('')
const id_course = ref(0)
const ref_course = ref('')
const id_classroom = ref(0)
const sedes = ref([])
const arrayFiles = ref([])
const listarDocuments = () => {
    let url = '/file/documents/list' + '?type=' + type.value + '&id_course=' + id_course.value + '&id_classroom=' + id_classroom.value + '&anioSearch=' + anioSearch.value; // <-- si no es el año lectivo actual tomar otra aula en el controller
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayFiles.value = respuesta.datalist;
        if (respuesta.error) {
            //showAlert(respuesta.message, 'danger', 16)
        }
        console.log(arrayFiles.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const selectedFiles = ref([])
const allowMultiple = ref(true)
const replace_file = ref(false)
const fileSize = ref(0)
const filepreviewlist = ref('')
const loaderUpload = ref(false)
const successUpload = ref(false)
const loaderUploads = ref([])
const successUploads = ref([])
props.apiSedes.forEach((loader, index) => {
    loaderUploads.value[index] = false
})
props.apiSedes.forEach((loader, index) => {
    successUploads.value[index] = false
})
const handleFileSelect = (event) => {

    selectedFiles.value = event.target.files;
    filepreviewlist.value = '<ol>';
    for (let i = 0; i < selectedFiles.value.length; i++) {
        filepreviewlist.value += '<li style="font-size: 12px">'
        filepreviewlist.value += selectedFiles.value[i].name;
        filepreviewlist.value += '</li>'
    }
    filepreviewlist.value += '</ol>';
    // You can now process the selected files, e.g., display their names or prepare for upload

    // Cada vez que se selecciona archivos se reseteará el color
    successUpload.value = false
    props.apiSedes.forEach((loader, index) => {
        successUploads.value[index] = false
    })

    //fileSubida.value = this.$refs.fileSubida.files[0];
    /* let file = null;
    if (type == 'file_document_student') {
        file = fileDocument.value.files[0];
    }

    //console.log(file);
    console.log(file.size);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if (file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }
    } */

}

// Cambiar ruta para /api/upload -> Para cada sede
const uploadFiles = async (ruta = '/file/uploads', sede_externa = 0, token = '', index_sede = null, user = '') => {

    if (!selectedFiles.value) {
        console.warn("No files selected for upload.");
        return;
    }
    //console.log(selectedFiles.value)

    const formData = new FormData();
    for (let i = 0; i < selectedFiles.value.length; i++) {
        formData.append('files[]', selectedFiles.value[i]); // 'files' is the field name on your server
    }
    //formData.append('files', selectedFiles.value)
    formData.append('type', type.value)
    formData.append('id_course', id_course.value)
    formData.append('ref_course', ref_course.value)
    formData.append('id_classroom', id_classroom.value)
    formData.append('replace_file', replace_file.value)
    formData.append('sede_externa', sede_externa)
    formData.append('user', user)

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(`Upload Progress: ${percentCompleted}%`);
            // Update a progress bar in your UI if needed
        }
    }

    if (sede_externa == 1) {
        ruta = ruta + '/api/file/uploads'
        config = {
            headers: {
                // -LRR 'Authorization: Token token= "' . $ecommerce_token . '"',
                'Authorization': 'Bearer ' + token + '',
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                console.log(`Upload Progress: ${percentCompleted}%`);
                // Update a progress bar in your UI if needed
            }
        }

        loaderUploads.value[index_sede] = true
    } else {
        loaderUpload.value = true
    }

    //console.log(replace_file.value)
    // Iniciar la api ruta aquí /api/upload -> Para cada sede <-- A futuro cambiar a cada sede

    try {


        /* const response = await axios.post(ruta, formData, {
            headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(`Upload Progress: ${percentCompleted}%`);
            // Update a progress bar in your UI if needed
        }
        });
        console.log('Upload successful:', response.data);
        // Handle successful upload (e.g., clear selected files, display success message) */

        await axios.post(ruta, formData, config)
            .then(response => {
                if (response.data.error) {
                    showAlert(response.data.message, 'danger', 10)
                } else if (response.data.success) {
                    showAlert(response.data.message, 'success', 5)
                    listarDocuments()
                    //cleanInputFile()
                    if (sede_externa == 1) {
                        successUploads.value[index_sede] = true
                    } else {
                        successUpload.value = true
                    }

                }
                console.log(response.data)
            })
            .catch(error => {
                console.log(error)
            })


    } catch (error) {
        console.error('Upload failed:', error);
        // Handle upload error (e.g., display error message)
    }
    if (sede_externa == 1) {
        loaderUploads.value[index_sede] = false
    } else {
        loaderUpload.value = false
    }

}

/* const handleSelectCourse = (event) => {
    //const selectedId = parseInt(event.target.value) // event.target.value will be string, but need number
    const selectedId = parseInt(event)

    // and actually, it only took adding one extra line to reference the original object
    if (selectedId > 0) {
        const selectedCourse = props.courses.find(option => option.value == selectedId);
        ref_course.value = selectedCourse.ref
        console.log('Curso seleccionado: ' + selectedCourse.ref)
    }
    
} */

/**
 * Section Alert
 */

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message, color, time = 1) => {

    messageAlert.value = message
    colorAlert.value = color

    isAlertActive.value = true

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

// Formatos de fecha y tiempo
const formatDate = (datesource, format = 'day') => {
    //var now = new Date().toLocaleDateString()
    if (datesource) {
        var date = new Date(datesource + 'T00:00:00')// <-- Con let no funcionaba <-- Agregar la hora para que no reste un día por la zona horaria del navegador
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = ''
        if (format == 'day') {
            result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        } else if ((format == 'Y')) {
            result = date.getFullYear()
        }

        return result
    }

}

//console.log(props.object)
const formatDateTime = (datetime) => {
    if (datetime) {
        var date = new Date(datetime)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        return result
    }

}

// Cargar vista modal Full para vista previa
const showVistaPrevia = (ruta = '', option = '') => {
    isModalFullActive.value = true
    modalFullSrc.value = ruta + (props.canWrite ? '' : '#toolbar=0') // <-- ocultar toolbar y a futuro ocultar context menu :oncontextmenu

    /* if (option == 'nodownload') {
        let buttondownload = document.getElementById('#downloads');
        if (buttondownload) {
            console.log('hide download preview')
            buttondownload.hide();
        }
    } */
}

</script>

<template>

    <Head :title="'Sílabo ' + course.label" />
    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />
    <BreezeAuthenticatedLayout>
        <template #header>
        <PremiumPageHeader title="{{ 'Sílabo del curso: ' + course.label + ', área:' + course.label_area }}" subtitle="Gestión de {{ 'sílabo del curso: ' + course.label + ', área:' + course.label_area }}">
            <template #buttons>
                <Link :href="route('classrooms-collaborator') + backLink" class="btn btn-blue w-full text-center">Volver al listado</Link>
            </template>
        </PremiumPageHeader>
    </template>

        <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')">
            <!-- <v-icon>{{ selectedEvent.icon }}</v-icon> -->
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} :
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <div v-html="selectedEvent.contentFull" />

            <div v-if="canUpdate">
                <BaseButton color="warning" :icon="mdiPencil" small label=" Modificar evento" class="" @click="initModal(selectedEvent.id, 'update', selectedEvent)" />
            </div>

            <div v-if="canDelete">
                <BaseButton color="danger" :icon="mdiTrashCan" small label=" Eliminar evento" class="" @click="initModal(selectedEvent.id, 'delete')" />
            </div>
            <!-- <strong>Info.:</strong>
                <ul>
                    <li>Inicio: {{ selectedEvent.start && selectedEvent.start.formatTime() }}</li>
                    <li>Fin: {{ selectedEvent.end && selectedEvent.end.formatTime() }}</li>
                </ul> -->
        </CardBoxModal>
        <CardBoxModal v-model="isModalActive" hasCancel :title="titleModal" @confirm="isConfirm" @cancel="isCancel">
            <div class="p-4 md:p-5 space-y-4 overflow-y-auto h-[450px]">
                <p class="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                    Puede crear actividades/eventos en su calendario.
                </p>
                <span v-if="errorEvent" v-text="errorEvent" class="text-red-500"></span>
                <div class="col-span-1">
                    <label>Tipo</label>
                    <select v-model="formEvent.type_source">
                        <option value="user_private" selected>Privado</option>
                        <option value="temario" selected>Temario</option>
                    </select>
                </div>
                <div v-if="formEvent.type_source == 'temario'" class="relative">
                    <label class="block font-bold mb-2 ml-2">Curso</label>
                    <select v-model="formEvent.id_source" class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                        <option value="0" selected>Escoge un curso</option>
                        <option v-for="option in courses" :value="option.id">{{ option.label_course + ' - ' + option.label_classroom }}</option>
                    </select>
                </div>
                <div class="col-span-1">
                    <label>{{ (formEvent.type_source == 'temario' ? 'Tema' : 'Título') }}</label>
                    <input type="text" v-model="formEvent.title" class="w-full">
                </div>
                <div class="flex justify-between items-center gap-2 w-full">
                    <div class="flex flex-col lg:flex-row gap-2">
                        <div class="inline-block">
                            Inicio: <input type="datetime-local" v-model="formEvent.start">
                        </div>
                        <div class="inline-block">
                            Fin: <input type="datetime-local" v-model="formEvent.end">
                        </div>
                    </div>

                </div>
                <div class="col-span-1">
                    <label>{{ (formEvent.type_source == 'temario' ? 'Contenidos básicos' : 'Descripción (Opcional)') }}</label>
                    <textarea value="" class="w-full" v-model="formEvent.contentFull"></textarea>
                </div>

            </div>
        </CardBoxModal>
        <CardBoxModal v-model="isModalDangerActive" title="Por Confirmar" button="danger" hasCancel @confirm="isConfirm" @cancel="isCancel">
            <p>Está seguro de <b>{{ titleModal }}</b></p>
            <p>este registro?</p>
        </CardBoxModal>

        <!-- Vista previa guia de estudio u otro -->
        <CardBoxModal v-model="isModalFullActive" title="Vista previa" sizeModal="full" hasCancel>
            <!-- tien el botón de cancelar superior-->
            <div class="flex justify-center w-full" :class="canWrite ? '' : 'view-wrapper'">
                <!-- src="modalFullSrc + (isCoord ? '#toolbar=0' : '')" class="min-h <-- Mejor mostrar siempre --> <!-- v-if="modalFullSrc && (['xlsx', 'pptx', 'docx'].includes(modalFullSrc.split('.').pop()))" -->
                <!-- :class="(modalFullSrc && (['pdf', 'xlsx', 'pptx', 'docx'].includes(modalFullSrc.split('.').pop())) ? 'w-full' : 'w-auto ')" -->
                <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full" :oncontextmenu="(canWrite ? true : false)"><!-- w-full es para documetnos w-auto para imágenes ---  Otro uso :style="(isCoord ? '#downloads {display: none;}' : '')" -->
                <!-- <WebViewer v-else :initialDoc="modalFullSrc"></WebViewer> -->
                <div v-if="!canWrite" class="view-embed-cover"></div>
            </div>
        </CardBoxModal>

        <div>
            <div class="bg-white overflow-hidden shadow-lg rounded-md border p-4">
                <div class="mb-6 flex justify-between">

                    <!-- subtitle -->
                    <!-- <ul>
                        <li>La configuración de semanas y temas lo realiza el coordinador</li>
                        <li>El rango de fechas por defecto es una sugerencia, usted lo puedo modificar al registrar el tema</li>
                        
                        </ul> -->

                </div>

                <div class="relative flex flex-col w-full h-full text-gray-700 bg-white mt-4">
                    <div class="overflow-y-auto min-h-[600px] max-h-[1000px]">
                        <table v-if="competencias.length" class="table-basic">
                            <thead>
                                <tr>
                                    <th colspan="4">Competencias de este ciclo curricular</th>
                                </tr>
                                <tr>
                                    <th>#</th>
                                    <th>Competencia</th>
                                    <th>Descripción</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(competencia, index) in competencias" :key="competencia.id">
                                    <td data-label="#" :title="competencia.id"> {{ index + 1 }}</td>
                                    <td data-label="Competencia">
                                        <div class="min-w-[450px]">{{ competencia.label }}</div>
                                    </td>
                                    <td data-label="Descripción"> {{ competencia.description }}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h3 class="text-xl font-bold">
                        Temas ({{ temas.length }}) de Semanas ({{ totalSemanas }})
                    </h3>
                    <br>
                    <div class="overflow-y-auto min-h-[600px] max-h-[1000px]">

                        <table v-if="totalSemanas > 0" class="table-basic">
                            <thead>
                                <tr>
                                    <th>Bimestre</th>
                                    <th>Semana</th>
                                    <th>Fecha</th>
                                    <!-- <th>N. Tema</th> -->
                                    <th>Tema</th>
                                    <th>Descripción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="semanasPrimerBimestre">
                                    <tr v-for="(semana, index) in semanasPrimerBimestre" :key="semana">
                                        <td v-if="index == 0" data-label="Bimestre" :rowspan="semanasPrimerBimestre.length"> 1</td>
                                        <td data-label="Semana"> {{ semana }}</td>
                                        <td data-label="Fecha"> </td>
                                        <!-- <td data-label="N. Tema"> </td> -->
                                        <td data-label="Tema">
                                            <div class="min-w-[450px]"> </div>
                                        </td>
                                        <td data-label="Contenidos básicos"> </td>

                                    </tr>
                                </template>
                                <template v-if="semanasSegundoBimestre.length">
                                    <tr v-for="(semana, index) in semanasSegundoBimestre" :key="semana">
                                        <td v-if="index == 0" data-label="Bimestre" :rowspan="semanasSegundoBimestre.length"> 2</td>
                                        <td data-label="Semana"> {{ semana }}</td>
                                        <td data-label="Fecha"> </td>
                                        <!-- <td data-label="N. Tema"> </td> -->
                                        <td data-label="Tema">
                                            <div class="min-w-[450px]"> </div>
                                        </td>
                                        <td data-label="Contenidos básicos"> </td>

                                    </tr>
                                </template>
                                <template v-if="semanasTercerBimestre.length">
                                    <tr v-for="(semana, index) in semanasTercerBimestre" :key="semana">
                                        <td v-if="index == 0" data-label="Bimestre" :rowspan="semanasTercerBimestre.length"> 3</td>
                                        <td data-label="Semana"> {{ semana }}</td>
                                        <td data-label="Fecha"> </td>
                                        <!-- <td data-label="N. Tema"> </td> -->
                                        <td data-label="Tema">
                                            <div class="min-w-[450px]"> </div>
                                        </td>
                                        <td data-label="Contenidos básicos"> </td>

                                    </tr>
                                </template>
                                <template v-if="semanasCuartoBimestre.length">
                                    <tr v-for="(semana4, index) in semanasCuartoBimestre" :key="semana4">
                                        <td v-if="index == 0" data-label="Bimestre" :rowspan="semanasCuartoBimestre.length"> 4</td>
                                        <td data-label="Semana"> {{ semana4 }}</td>
                                        <td data-label="Fecha"> </td>
                                        <!-- <td data-label="N. Tema"> </td> -->
                                        <td data-label="Tema">
                                            <div class="min-w-[450px]"> </div>
                                        </td>
                                        <td data-label="Contenidos básicos"> </td>

                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div>

            <div class="bg-white overflow-hidden shadow-lg rounded-md border p-4">
                <div class="mb-6 flex justify-between">

                    <!-- subtitle -->
                    <ul>
                        <li>Puede subir varios archivos a la vez</li>
                        <li>Debe establecer un estándar en los nombres de archivos pues así se guardarán (sin símbolos)</li>

                    </ul>

                </div>

                <div class="relative flex flex-col w-full h-full text-gray-700 bg-white mt-4">
                    <h3 class="text-xl font-bold">
                        Listado de Documentos ({{ arrayFiles.length }})
                    </h3>
                    <div class="overflow-y-auto min-h-[600px] max-h-[1000px]">
                        <table class="w-full max-h-[1000px] text-left table-auto min-w-max table-collapse">
                            <thead class="top-0 mt-0 sticky bg-white">
                                <tr>
                                    <th colspan="2" class="p-0 w-[300px]">
                                        <div class="flex justify-between w-full items-center gap-4 p-4 border-b h-[70px]">
                                            <div class="flex justify-center items-center p-4 h-[70px]">
                                                <BaseButton color="info" :icon="mdiMagnify" small class="" @click="listarDocuments()" />
                                            </div>

                                            <div class="w-full ">
                                                <!-- @update:modelValue="handleSelectCourse" ->  -->
                                                <!-- <VueSelect class="select-search-light w-full min-w-[150px]" v-model="id_course" :options="courses" @update:modelValue="handleSelectCourse" :get-option-label="(option) => `${option.label} - ${option.ref_level}`" :placeholder="'Curso - Todos'"/> -->
                                            </div>

                                            <div class="w-full">
                                                <select class="w-full min-w-[150px]" v-model="type">
                                                    <option value="" selected>Documento - Todos</option>
                                                    <option value="file_guideforcourse">Guía de estudio</option>
                                                    <option value="file_adviceforcourse">Asesoría</option>
                                                    <option value="file_motivationforcourse">Motivación</option>
                                                    <!-- Asociadas al aula -->
                                                    <!-- <option value="file_resource">Recurso de estudio</option>
                                                        <option value="file_task">Tareas</option>
                                                        <option value="file_taskresp">Tareas Respuestas</option> -->
                                                </select>
                                                <!-- <div class="relative">
                                                        <input class="w-full py-2 px-4 border font-normal border-gray-300 rounded-md focus:outline-none focus:ring-2" type="search" placeholder="Filtrar">
                                                        <button class="absolute inset-y-0 right-0 flex items-center px-2  rounded-r-md btn-outline-light">
                                                            <BaseIcon :path="mdiMagnify" :size="26" class="h-10 w-10" />
                                                        </button>
                                                    </div> -->
                                            </div>
                                        </div>
                                    </th>
                                    <th v-if="canWrite" class="p-0">
                                        <div class="flex justify-between items-center p-4 border-b h-[70px]">
                                            <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                Subir Archivos
                                            </p>
                                        </div>
                                    </th>

                                    <th class="p-0">
                                        <div class="flex justify-between items-center p-4 border-b min-h-[70px]">
                                            <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                Creado/Modif.
                                                <input name="year" class="w-16 ml-3 rounded-md font-normal" type="text" v-model="anioSearch">
                                                <!-- :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR" -->
                                            </p>

                                        </div>
                                    </th>
                                    <th class="p-0">
                                        <div class="flex justify-between items-center p-4 border-b min-h-[70px]">
                                            <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                Autor
                                            </p>

                                        </div>
                                    </th>
                                    <!-- <th class="p-0">
                                            <div class="flex justify-between items-center p-4 border-b h-[70px]">
                                                <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                    Actualizado
                                                </p>

                                            </div>
                                        </th>
                                        <th class="p-0">
                                            <div class="flex justify-between items-center p-4 border-b h-[70px]">
                                                <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                    Autor
                                                </p>

                                            </div>
                                        </th> -->
                                    <th class="p-0">
                                        <div class="p-4 flex items-center justify-center border-b min-h-[70px] text-sm font-semibold">
                                            Action
                                        </div>
                                    </th>
                                </tr>
                                <tr v-if="canWrite && id_course > 0 && type">
                                    <th class="p-0 border-b" colspan="2">
                                        <div class="flex items-center p-2 min-h-[70px] gap-2">
                                            <div class="flex items-center gap-2">
                                                <BaseIcon :path="mdiCloudUploadOutline" :size="26" class="h-10 w-6 text-gray-700 mr-4 inline-block" /> <input id="upload-file" type="file" @change="handleFileSelect" :multiple="allowMultiple" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS" />
                                            </div>
                                            <div>
                                                <div v-html="filepreviewlist" class="font-normal"></div>
                                            </div>
                                        </div>
                                        <!-- <div class="flex flex-row items-center p-4 border-b gap-2 h-[70px]">
                                                
                                                <div class="flex justify-between items-center min-w-[442px] w-full">
                                                    <label for="upload-file" class="flex flex-col items-center justify-center w-full border border-gray-300 border-dashed rounded-md cursor-pointer bg-gray-50  hover:bg-gray-100 h-[38px]">
                                                        <div class="inline-flex items-center justify-center px-4">
                                                            <BaseIcon :path="mdiCloudUploadOutline" :size="26" class="h-10 w-6 text-gray-700 mr-4 inline-block" />
                                                            <span class="font-normal text-xs" v-html="filepreviewlist"></span>
                                                            <p class="text-sm font-normal text-gray-700 ">Para subir un archivo, <span class="font-semibold">arrastrar o click aquí</span></p>
                                                        </div>
                                                        <div class="inline-flex items-center justify-center px-4">
                                                            <input id="upload-file" type="file" @change="handleFileSelect" :multiple="allowMultiple" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS"/>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div> -->
                                    </th>
                                    <th class="p-0 border-b" colspan="5">
                                        <div class="flex items-center py-4 px-2 h-[70px] gap-2">
                                            <!-- <div role="button" class="flex items-center h-full">
                                                    <input type="checkbox" class="appearance-none hidden peer sr-only" id="id-01" />
                                                    <label class="h-full flex items-center text-xs cursor-pointer font-medium text-slate-600 whitespace-nowrap peer-checked:bg-emerald-500 peer-checked:border-emerald-500 peer-checked:text-white hover:bg-slate-100 focus:bg-slate-100 px-2 py-1 border rounded-md p-0 transition-all ease-in-out" for="id-01">
                                                        Carabayllo
                                                    </label>
                                                </div>
                                                <div role="button" class="flex items-center h-full">
                                                    <input type="checkbox" class="appearance-none hidden peer sr-only" id="id-02" />
                                                    <label class="h-full flex items-center text-xs cursor-pointer font-medium text-slate-600 whitespace-nowrap peer-checked:bg-emerald-500 peer-checked:border-emerald-500 peer-checked:text-white hover:bg-slate-100 focus:bg-slate-100 px-2 py-1 border rounded-md p-0 transition-all ease-in-out" for="id-02">
                                                        Tomas Valle
                                                    </label>
                                                </div>
                                                <div role="button" class="flex items-center h-full">
                                                    <input type="checkbox" class="appearance-none hidden peer sr-only" id="id-03" />
                                                    <label class="h-full flex items-center text-xs cursor-pointer font-medium text-slate-600 whitespace-nowrap peer-checked:bg-emerald-500 peer-checked:border-emerald-500 peer-checked:text-white hover:bg-slate-100 focus:bg-slate-100 px-2 py-1 border rounded-md p-0 transition-all ease-in-out" for="id-03">
                                                        Pro
                                                    </label>
                                                </div>
                                                <div role="button" class="flex items-center h-full">
                                                    <input type="checkbox" class="appearance-none hidden peer sr-only" id="id-04" />
                                                    <label class="h-full flex items-center text-xs cursor-pointer font-medium text-slate-600 whitespace-nowrap peer-checked:bg-emerald-500 peer-checked:border-emerald-500 peer-checked:text-white hover:bg-slate-100 focus:bg-slate-100 px-2 py-1 border rounded-md p-0 transition-all ease-in-out" for="id-04">
                                                        San Felipe
                                                    </label>
                                                </div> -->

                                            <!-- Deprecated -->
                                            <!-- <div class="ml-2">
                                                        <BaseButton :color="successUpload ? 'success' : 'light'" :label="loaderUpload ? '' : (apiSedes.length > 0 ? confGlobal.value.UNENS_SEDE_NOMBRE : 'Subir Archivos')" @click="uploadFiles()" :class="loaderUpload ? 'inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2' : ''"></BaseButton>
                                                    
                                                        <template v-if="apiSedes.length > 0" class="ml-2">
                                                            <BaseButton v-for="(sede, index) in apiSedes" :key="index" :color="successUploads[index] ? 'success' : 'light'" :label="loaderUploads[index] ? '' : sede.label" @click="uploadFiles(sede.ruta, 1, sede.token, index)" :class="loaderUploads[index] ? 'inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2' : 'ml-2'"></BaseButton>
                                                        </template>
                                                    </div> -->

                                            <!-- En lugar de input simples botones -->
                                            <span @click="uploadFiles()" class="inline-flex items-center whitespace-nowrap leading-none font-normal text-xs border rounded-md py-1 px-2" :class="successUpload ? 'text-white bg-emerald-500 border-emerald-500' : 'text-gray-700 bg-gray-50'">
                                                {{ loaderUpload ? '' : (apiSedes.length > 0 && canWriteSedes ? confGlobal.value.UNENS_SEDE_NOMBRE : 'Subir Archivos') }}
                                                <span v-if="loaderUpload" class="inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2" />
                                            </span>

                                            <!-- Si existen sedes externas -->
                                            <template v-if="apiSedes.length > 0 && (canReadSedes || canWriteSedes)">
                                                <span v-for="(sede, index) in apiSedes" :key="index" @click="uploadFiles(sede.ruta, 1, sede.token, index, $page.props.auth.user.user)" class="inline-flex items-center whitespace-nowrap leading-none font-normal text-xs border rounded-md py-1 px-2" :class="successUploads[index] ? 'text-white bg-emerald-500 border-emerald-500' : 'text-gray-700 bg-gray-50'">
                                                    {{ loaderUploads[index] ? '' : sede.label }}
                                                    <span v-if="loaderUploads[index]" class="inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2" />
                                                </span>
                                            </template>

                                            <span class="font-normal text-xs" :class="replace_file ? 'text-red-600' : ''">Reemplazar archivo con el mismo nombre</span>
                                            <input type="checkbox" v-model="replace_file"></input>
                                        </div>
                                    </th>
                                    <!-- <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">
                                                
                                            </div>
                                        </th>
                                        <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">

                                            </div>
                                        </th> -->
                                    <!-- <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">
                                                
                                            </div>
                                        </th>
                                        <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">

                                            </div>
                                        </th> -->
                                    <!-- <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">

                                            </div>
                                        </th> -->
                                </tr>
                            </thead>
                            <tbody class="overflow-y">
                                <!-- START 1ER CURSO -->
                                <!-- START 1ER CURSO -->
                                <tr v-for="file in arrayFiles" :key="file.id">
                                    <td class="border-b border-r bg-white px-4" rowspan="">
                                        <div class="flex items-center">
                                            <h2 :title="file.course_id">{{ file.course_label + ' - ' + file.level_ref }}</h2>
                                        </div>
                                    </td>
                                    <td class="px-2 py-4 border-b max-w-[700px]">
                                        <div class="flex h-full gap-2">
                                            <BaseIcon :path="mdiCircle" :size="8" class="h-4 w-4 mr-2 inline-block" />
                                            <p class="font-medium text-xs text-gray-700"> {{ file.name }}
                                                <span v-if="!type">
                                                    <small v-if="file.type == 'file_guideforcourse'">
                                                        (Guía de estudio)
                                                    </small>
                                                    <small v-else-if="file.type == 'file_adviceforcourse'">
                                                        (Asesoría)
                                                    </small>
                                                    <small v-else-if="file.type == 'file_motivationforcourse'">
                                                        (Motivación)
                                                    </small>
                                                </span>
                                            </p>
                                            <!-- <div class="flex items-center px-2 py-1 font-medium text-xs text-gray-700 rounded-md select-none bg-gray-100 border h-[26px]">
                                                    <p>
                                                        <BaseIcon :path="mdiCircle" :size="8" class="h-4 w-4 mr-2" />{{ file.description }}
                                                    </p>
                                                </div> -->
                                        </div>
                                    </td>
                                    <td v-if="canWrite" class="p-2 border-b align-center">
                                        <!-- A futuro consultar si existe el archivo en cada sede -->
                                        <div v-if="confGlobal.value.MAIN_FEATURES_LEVEL == 3 && apiSedes.length > 0 && (canReadSedes || canWriteSedes)" class="flex h-full flex-nowrap gap-2 mim-h-[26px]">
                                            <div class="flex items-center ">
                                                <span class="inline-flex items-center whitespace-nowrap leading-none text-xs border rounded-md py-1 px-2 text-white bg-emerald-500 border-emerald-500">
                                                    Carabayllo
                                                </span>
                                            </div>
                                            <div class="flex items-center ">
                                                <span class="inline-flex items-center whitespace-nowrap leading-none text-xs border rounded-md py-1 px-2 text-gray-700 bg-gray-50">
                                                    Tomas Valle
                                                    <span v-if="1 == 1" class="inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2" />
                                                </span>

                                            </div>
                                            <div class="flex items-center ">
                                                <span class="inline-flex items-center whitespace-nowrap leading-none text-xs border rounded-md py-1 px-2 text-gray-700 bg-gray-50">
                                                    Pro
                                                </span>
                                            </div>
                                            <div class="flex items-center ">
                                                <span class="inline-flex items-center whitespace-nowrap leading-none text-xs border rounded-md py-1 px-2 text-gray-700 bg-gray-50">
                                                    San Felipe
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="p-2 border-b align-center">
                                        <div class="flex flex-col gap-2">
                                            {{ formatDateTime(file.created_at) }}
                                            <small v-if="file.created_at != file.updated_at">
                                                {{ formatDateTime(file.updated_at) }}
                                            </small>
                                        </div>
                                    </td>
                                    <td class="p-2 border-b align-center">
                                        <div class="flex flex-col gap-2">
                                            <p>{{ file.nombre_usuario_modif }}</p>
                                        </div>
                                    </td>
                                    <!-- <td class="p-2 border-b align-center">
                                            <div class="flex flex-col gap-2">
                                                {{ formatDateTime(file.updated_at) }}
                                            </div>
                                        </td>
                                        <td class="p-2 border-b align-center">
                                            <div class="flex flex-col gap-2">
                                                <p>{{ file.nombre_usuario_modif }}</p>
                                            </div>
                                        </td> -->
                                    <td class="p-2 border-b align-center">
                                        <div class="flex items-center h-full gap-2">
                                            <!-- <BaseButton v-if="canEdit" color="warning" :icon="mdiPencil" small class="" /> -->


                                            <!-- <BaseButton v-if="canView" color="info"
                                                    :icon="mdiEye" small
                                                    :href="route('pdf-viewer', { 'name': file.name, 'ruta': '/documents/' + file.filepath + '/' + file.filename })"
                                                    target="_blank" /> -->
                                            <BaseButton v-if="canView" color="info" :icon="mdiEye" small @click="showVistaPrevia('/documents/' + file.filepath + '/' + file.filename, 'nodownload')" class="hidden lg:grid" />
                                            <BaseButton v-if="canDownload" color="info" :icon="mdiDownload" small :href="route((file.origin_id2 && file.origin_id2 > 0 ? 'file-download2' : (file.origin_id && file.origin_id > 0 ? 'file-download' : 'file-download')), { 'srctype': file.type, 'srcid': (file.src_object_id ? file.src_object_id : 0), 'filename': file.filename, 'srcid2': (file.origin_id2 ? file.origin_id2 : 0) })" target="_blank" @click="" />
                                            <BaseButton v-if="canDelete || file.user_modif == $page.props.auth.user.id" color="danger" :icon="mdiTrashCan" small class="" @click="initModal(file.id, 'eliminar')" />
                                        </div>
                                    </td>
                                </tr>

                                <!-- END 1ER CURSO -->
                                <!-- END 1ER CURSO -->

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </BreezeAuthenticatedLayout>
</template>
<style scope></style>
